import axios from "axios";
import { BASE_URL } from "./constants";

export const getFeed = (token: string) => {
  console.log({ token });
  return axios.get(`${BASE_URL}/getfeed`, { params: { token } });
};
